<template>
  <b-modal
    v-model="model"
    size="lg"
    hide-footer
    centered
  >
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      rounded="sm"
    >
      <h1 class="font-large-1 text-center pt-2">
        Añadir cuenta bancaria
      </h1>
      <validation-observer ref="configuration-sale-invoice-type-form">
        <b-form
          class="py-2"
          @submit.prevent
        >
          <b-row align-h="center">
            <b-col
              sm="12"
              lg="10"
            >
              <validation-provider
                v-slot="validationContext"
                name="Nombre"
                rules="required"
              >
                <b-form-group
                  label="Nombre"
                  label-for="sale-invoice-type-name"
                >
                  <b-form-input
                    id="sale-invoice-type-name"
                    v-model="formModel.name"
                    :state="$getValidationState(validationContext)"
                  />
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              sm="12"
              lg="10"
            >
              <validation-provider
                v-slot="validationContext"
                name="Operación"
                rules="required"
              >
                <b-form-group
                  label="Operación"
                  label-for="sale-invoice-type-operation"
                >
                  <b-form-input
                    id="sale-invoice-type-operation"
                    v-model="formModel.operation_type"
                    :state="$getValidationState(validationContext)"
                  />
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              sm="12"
              lg="10"
            >
              <validation-provider
                v-slot="validationContext"
                name="Concepto de imputación"
                rules="required"
              >
                <b-form-group
                  label="Concepto de imputación"
                  label-for="sale-invoice-concept-inputation-id"
                >
                  <b-form-input
                    id="sale-invoice-concept-inputation-id"
                    v-model="formModel.concept_inputation_id"
                    type="number"
                    :state="$getValidationState(validationContext)"
                  />
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
        <b-row align-h="center">
          <b-col cols="auto">
            <b-button
              variant="primary"
              class="text-nowrap rounded-sm px-2"
              @click="handleAcceptButtonClick"
            >
              Aceptar
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import ApiRestService from '@/api/base-api'

export default {
  name: 'SaleInvoiceTypeCreationModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      formModel: {
        name: '',
        operation_type: '',
      },
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    async handleAcceptButtonClick() {
      const valid = await this.$refs['configuration-sale-invoice-type-form'].validate()
      if (!valid) {
        return
      }

      this.loading = true
      try {
        await ApiRestService.create(this.formModel, this.$data.$constants.RESOURCES.RESOURCE_SALE_INVOICE_TYPES)
        this.$emit('input', false)
        this.$emit('sale-invoice-type-creation')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
</style>
